import { render, staticRenderFns } from "./gradeResultadosProdutos.vue?vue&type=template&id=03840a78&scoped=true"
import script from "./gradeResultadosProdutos.vue?vue&type=script&lang=js"
export * from "./gradeResultadosProdutos.vue?vue&type=script&lang=js"
import style0 from "./gradeResultadosProdutos.vue?vue&type=style&index=0&id=03840a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03840a78",
  null
  
)

export default component.exports